module.exports = __webpack_public_path__ + "files/d4ef5a98c1241cb710f1844dc59be5f3.svg";